module.exports = __webpack_public_path__ + "img/bernerzeitung.89f2561b.png";